const getCalendarData = (state) => { return state.calendarData }

const getIsLoading = (state) => { return state.isLoading }

const getVerifiedBookings = (state) => { return state.verifiedBookings }

const getBookingDetails = (state) => { return state.bookingDetails }

const getBillItemDetails = (state) => { return state.billItemDetails }

const getBookingPaidStatusArray = (state) => { return state.bookingPaidStatusArray }

const getPaymentMethodsAliases = (state) => {  return JSON.parse(JSON.stringify(state.paymentMethodsAliases)) }

export default {
    getCalendarData,
    getIsLoading,
    getBookingDetails,
    getVerifiedBookings,
    getBillItemDetails,
    getBookingPaidStatusArray,
    getPaymentMethodsAliases
}
